import {
  createSlice,
  createAsyncThunk,
  createAction,
  createSelector,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { IItemInfo } from "../interface/IItem";
import { HeaderParamsModel } from "../model/common";
import ItemService from "../service/ItemService";
import { RootState } from "../store/store";

import { logoutUser } from "./common";

export const resetItem = createAction("item/reset");

const _service = new ItemService();

export const getItemsAsync = createAsyncThunk(
  "item/getAllItems",
  async (params) => {
    const response = await _service.getItemsService(params);
    return response;
  }
);

export const getItemsByAddressAndDateAsync = createAsyncThunk(
  "item/getItemsByAddressAndDate",
  async (params: HeaderParamsModel) => {
    const response = await _service.getItemsByAddressAndDateService(params);
    return response;
  }
);

type SliceState = {
  value: IItemInfo[];
  status: string;
  apiCallCount: number;
  detailStatus: string;
};
const initialState = {
  value: [],
  status: COMMON_STATUS.INITIAL,
  apiCallCount: 0,
  detailStatus: COMMON_STATUS.INITIAL,
} as SliceState;

// const itemAdapter = createEntityAdapter({
//   selectId: (item:IItemInfo) => item.id,
// })

export const itemSlice = createSlice({
  name: "item",
  // initialState: itemAdapter.getInitialState({
  //   status: COMMON_STATUS.INITIAL,
  // }),
  initialState,
  reducers: {
    updateItemMaxCapacityFromCart: (state: SliceState, action) => {
      action.payload.map((m: any) => {
        const found = state.value.find((item) => item.id === m.id);
        if (found) {
          found.maxCapacityItemInfoVm = {
            itemId: m.id,
            maxCapacity: m.maxCapacity,
            totalOrdersValue: m.totalOrders,
          };
        }
      });
    },
  },
  extraReducers: (builder) => {
    builder
      //For getItems ByTrader
      .addCase(getItemsAsync.pending, (state: SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getItemsAsync.fulfilled, (state: SliceState, action) => {
        state.value = action.payload;
        state.status = COMMON_STATUS.LOADED;
      })
      .addCase(getItemsAsync.rejected, (state: SliceState, action) => {
        state.status = COMMON_STATUS.FAILED;
      })

      //For items getBy Addres and Date
      .addCase(getItemsByAddressAndDateAsync.pending, (state: SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(
        getItemsByAddressAndDateAsync.fulfilled,
        (state: SliceState, action) => {
          state.value = action.payload;
          state.status = COMMON_STATUS.LOADED;
        }
      )
      .addCase(
        getItemsByAddressAndDateAsync.rejected,
        (state: SliceState, action) => {
          state.status = COMMON_STATUS.FAILED;
        }
      )

      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetItem, (n) => {
        return initialState;
      });
  },
});
export const { updateItemMaxCapacityFromCart } = itemSlice.actions;
export const getItemList = (state: RootState) => state.item;
export const getItemListDetail = (state: RootState) => state.item.value;
export const getItemStatus = (state: RootState) => state.item.status;

export default itemSlice.reducer;
